export const fsFormThankYouUrlsDict = {
  en: '/thank-you-order-en/',
  de: '/de/thank-you-order/',
  ru: '/ru/thank-you-order/',
  tr: '/tr/thank-you-order/',
};

export const fsFormSfRecordTypesDict = {
  en: '012580000006MylAAE',
  // TODO replace with actual values
  de: '',
  ru: '0124H000000kMjPQAU',
  // TODO replace with actual values
  tr: '',
};

export const fsFormAcknowledgeDict = {
  en: 'I acknowledge that this program requires a',
  de: 'Ich bestätige, dass dieses Programm ein(e) erfordert',
  ru: 'Я понимаю, что эта программа требует ',
  tr: 'Bu programın bir gereksinim olduğunu kabul ediyorum',
};

export const fsFormButtonDict = {
  en: 'Download practical guide',
  de: 'Praktischen Leitfaden herunterladen',
  ru: 'Скачать руководство',
  tr: 'Pratik rehberi indir',
};

export const fsFormGoalTitleDict = {
  en: 'What are your goals to obtaining',
  de: 'Was sind Ihre Ziele beim Erwerb von',
  ru: 'Какие задачи вы хотите решить с помощью',
  tr: 'Elde etmek için hedefleriniz nedir',
};

export const fsFormGoalSpecifyDict = {
  en: 'Please specify the goal you would like to reach',
  de: 'Bitte geben Sie das Ziel an, das Sie erreichen möchten',
  ru: 'Уточните, пожалуйста, какие задачи вы хотите решить',
  tr: 'Ulaşmak istediğiniz hedefi belirtin',
};

export const fsFormGoalDict = {
  visaFreeTravelling: {
    en: 'Visa-free travelling',
    de: 'Visafreies Reisen',
    ru: 'Путешествия без виз',
    tr: 'Vizesiz seyahat',
  },
  justInCaseAsAPlanB: {
    en: 'Just in case, as a plan “B”',
    de: 'Nur für den Fall, als Plan “B”',
    ru: 'На всякий случай',
    tr: 'Her ihtimale karşı, “B” planı olarak',
  },
  forChildren: {
    en: 'For children',
    de: 'Für Kinder',
    ru: 'Для детей',
    tr: 'Çocuklar için',
  },
  taxOptimization: {
    en: 'Tax optimization',
    de: 'Steueroptimierung',
    ru: 'Оптимизация налогообложения',
    tr: 'Vergi optimizasyonu',
  },
  relocation: {
    en: 'Relocation',
    de: 'Umsiedlung',
    ru: 'Переезд',
    tr: 'Taşınma',
  },
  other: {
    en: 'Other',
    de: 'Andere',
    ru: 'Другое',
    tr: 'Diğer',
  },
};

export const fsFormMinAmountDict = {
  en: {
    investment: 'minimum investment of {minAmount}',
    monthlyIncome: 'minimum monthly income of {minAmount}',
  },
  de: {
    investment: 'minimale Investition von {minAmount}',
    monthlyIncome: 'monatliches Mindesteinkommen von {minAmount}',
  },
  ru: {
    investment: 'минимальных инвестиций в размере от {minAmount}',
    monthlyIncome: 'подтвержденный доход в размере от {minAmount} в месяц',
  },
  tr: {
    investment: '{minAmount} tutarında minimum yatırım',
    monthlyIncome: '{minAmount} tutarında minimum aylık gelir',
  },
};
